angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
 "LANGUAGES": {
  "ARABIC": "Arabic",
  "AZERBAIJANI": "Azerbaijani",
  "DANISH": "Danish",
  "GERMAN": "German",
  "BELORUSSIAN": "Belorussian",
  "DUTCH": "Dutch",
  "GREEK": "Greek",
  "JAPANESE": "Japanese",
  "PORTUGUESE": "Portuguese",
  "ITALIAN": "Italian",
  "POLISH": "Polish",
  "SPANISH": "Spanish",
  "SWEDISH": "Swedish",
  "BULGARIAN": "Bulgarian",
  "ENGLISH": "English",
  "HEBREW": "Hebrew",
  "KOREAN": "Korean",
  "ROMANIAN": "Romanian",
  "THAI": "Thai",
  "CATALAN": "Catalan",
  "ESTONIAN": "Estonian",
  "HINDI": "Hindi",
  "LATVIAN": "Latvian",
  "RUSSIAN": "Russian",
  "TURKISH": "Turkish",
  "CHINESE": "Chinese",
  "FILIPINO": "Filipino",
  "HUNGARIAN": "Hungarian",
  "LITHUANIAN": "Lithuanian",
  "SERBIAN": "Serbian",
  "UKRAINIAN": "Ukrainian",
  "CROATIAN": "Croatian",
  "FINNISH": "Finnish",
  "ICELANDIC": "Icelandic",
  "NORWEGIAN": "Norwegian",
  "SLOVAK": "Slovak",
  "URDU": "Urdu",
  "CZECH": "Czech",
  "FRENCH": "French",
  "INDONESIAN": "Indonesian",
  "PERSIAN": "Persian",
  "SLOVENIAN": "Slovenian",
  "VIETNAMESE": "Vietnamese",
  "NEPALI": "Nepali",
  "ARMENIAN": "Armenian",
  "KURDISH": "Kurdish",
  "BENGALI": "Bengali",
  "GEORGIAN": "Georgian",
  "LUXEMBOURGISH": "Luxembourgish",
  "AFRIKAANS": "Afrikaans",
  "PUNJABI": "Punjabi",
  "SIGN": "Sign",
  "BASQUE": "Basque",
  "BOSNIAN": "Bosnian"
 }
}
);  }]);


//////////////////
// WEBPACK FOOTER
// ./webpack_loaders/nls.js!./app/src/constants/languages.json
// module id = 118
// module chunks = 24